module.exports = __webpack_public_path__ + "media/lineas/5-5d68b22d.png";